module.exports = __webpack_public_path__ + "static/media/sk.ef4d846b.png";